import { atom } from "recoil"

// top and bottom are measured in pixels
export type NativeMobileSafeAreaState = {
    top: number
    bottom: number
    enableTopSafeArea: boolean
    enableBottomSafeArea: boolean
}

export const nativeMobileSafeAreaAtom = atom<NativeMobileSafeAreaState>({
  key: "nativeMobileSafeAreaAtom",
  default: { 
    top: 0, 
    bottom: 0,
    enableTopSafeArea: true, 
    enableBottomSafeArea: true
  },
})
